//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamTraProUdalost.ts						</Name>
//    <Description> Dialog seznam Ud�lost										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-09-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(ginsevn) GID:(Web.Set.Ts) V1:(evn_por_cislo,log_por_cislo,iud_por_od,iud_por_do,dat_evn,ktg_evn,typ_evn,res_evn,proces_id,proces_txt,typ_subj,sxs_subj,tab_name,proces_src,klas_evn,ixs_aus,priz_zobr,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
	export class SeznamTraProUdalost extends GContentBase<SeznamTraProUdalostDesigner>  {

		private panelIdParametry: string;
		private gridFormatParametry: Data.GridFormat<any>;
		private panelParametry: JQuery<HTMLElement>;

		//#region *** onContentReady && Init ***

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {
            // inicializace hodnot od rodice
            SeznamTraProUdalostDesigner.SeznamTraProUdalostDesignerInit(this, this.evn_por_cislo, this.ktg_evn );
			this.setTitle();
			this.createMenuBar();
            this.createGrid();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
                this.title = "jres:29802537" 	//RC 29802537 : Ud�lost
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			return this.actions.createBar(["actDetail*"]);
		}

		/**
		 * vytvo�it menu
		 */
		private createMenuBar(): void {
			this.actions.addRange({
				actDetail: {
					icon: "gi-detail",
					caption: "jres:32131033",
					run: () => {
						this.openDetail();
					}
				}
			})
			this.menuBar(this.actions.createBar(["actDetail*"]));
		}

		//#region *** detail ***

		/**
		 * otev��t detail
		 */
        private openDetail(_new?: boolean): void {

            var newRecord = _new == null ? false : _new;

                if (newRecord === true) 
                    Dialogs.DetailTraProUdalostDlg(this, { evn_por_cislo: this.evn_por_cislo, grid: this.grid, newRecord: newRecord }).done((data: any) => {     });
				else if (Utils.isGridEmpty(this.grid))
					SeznamBase.createWarningNot(this, { title: "jres:29802537", text: "jres:32131036", id: "id-flash-select-more-rows-grid-detail" })
            else {
				var selection = this.grid.ggrid("getSelection");
                // vybran� jeden ��dek
				if (selection.length === 1) {
                    var data: any = selection[0];
                    Dialogs.DetailTraProUdalostDlg(this, { evn_por_cislo: data.evn_por_cislo, grid: this.grid, newRecord: newRecord }).done((data: any) => {         });
                }
				else
					SeznamBase.createWarningNot(this, { title: "jres:29802537", text: "jres:32131037", id: "id-flash-select-more-rows-grid-detail" })
			}

		}

		//#endregion

		//#region *** grid ***

		/** vytvo�it seznam - definice objektu GRIDu, nav�zan�ch ud�lost� atd... */
		private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				dataKey: "evn_por_cislo",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				defaultAction: this.actions.actDetail,
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextov� menu
                sort: "evn_por_cislo",									    // �azen� seznamu 
				selection: (ev, obj) => {
					this.actions.actDetail?.update({ enabled: obj.count == 1 })
					this.row = obj.getSelection();
					this.refreshPanel();
					this.refreshPanelParametry();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvo�it sidebar */
		private createSidebar() {
			this.removeSidebar();
			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: [this.createPanel(), this.createPanelParametry()]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target));
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		private createPanelParametry(): GSideBarPanelOptions {
			this.panelIdParametry = "panelParamnetry";
			let panel = {
				minWidth: 400,
				id: this.panelIdParametry,
				caption: "jres:33000133",							
				leaf: "jres:33000133",		
				icon: "gi-slider2",
				open: (ev, obj) => {
					this.refreshPanelParametry($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
        }

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// o�et�en� zav�en� contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;

			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
			    GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		private refreshPanelParametry(elementPanel?: JQuery<HTMLElement>): void {
			if (this.row.length > 0) {
				this.isl.TraProUdalostParametr.list({ filters: { evn_por_cislo: this.row[0].evn_por_cislo } }).getData().done((o) => {
					var panel: JQuery<HTMLElement> | undefined;
					if (this.closed)	// o�et�en� zav�en� contentu
						return;

					if (this.sidebar !== undefined)
						panel = this.sidebar.gsidebar("getPanel", this.panelIdParametry);
					else
						panel = elementPanel;
					if (panel !== undefined) {
						if (this.panelParametry !== undefined)
							this.panelParametry.remove();
						this.panelParametry = $("<div>").appendTo(panel).gtable({
							columns: this.createGridFormatParametry(),
							breakWidth: 200,
							data: o
						})
					}
				})
			}
		}

		private createGridFormatParametry(): Data.GridFormat<any> {
			if (this.gridFormatParametry)
			    return this.gridFormatParametry;
			this.gridFormatParametry = new Gordic.Data.GridFormat()
				.addTextColumn({
					name: "var_name_txt",
					caption: "jres:33000135", //RC 33000135 : Parametr ud�losti
					width: 250,
				})
				.addTextColumn({
					name: "var_value_txt",
					caption: "jres:29932124"
				})
			return this.gridFormatParametry;
        }

		//#endregion

	}

}
